namespace RioERP.Products {
    export namespace ProductBillingItemSpecificationsService {
        export const baseUrl = 'Products/ProductBillingItemSpecifications';

        export declare function Create(request: Serenity.SaveRequest<ProductBillingItemSpecificationsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ProductBillingItemSpecificationsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ProductBillingItemSpecificationsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ProductBillingItemSpecificationsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Products/ProductBillingItemSpecifications/Create",
            Update = "Products/ProductBillingItemSpecifications/Update",
            Delete = "Products/ProductBillingItemSpecifications/Delete",
            Retrieve = "Products/ProductBillingItemSpecifications/Retrieve",
            List = "Products/ProductBillingItemSpecifications/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ProductBillingItemSpecificationsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
